import { TProjectWithRegionsState } from './types';

export function getListOfProjects(state: TProjectWithRegionsState) {
  return state.listOfProjects;
}

export function getProjectsWithForeignParticipationDatesCount(state: TProjectWithRegionsState) {
  return state.projectsWithForeignParticipationDatesCount;
}

export function getIsLoadingCount(state: TProjectWithRegionsState) {
  return state.isLoadingCount;
}
